import { List } from 'immutable';
import { Tag as NavigationTag } from '@xanadu/ui-shared/modules/navigation/reducer';

export const CURRENCY_SHORT_SYMBOLS = {
  AUD: '$',
  BRL: '$',
  CAD: '$',
  CNY: '¥',
  EUR: '€',
  GBP: '£',
  HKD: '$',
  IDR: 'Rp',
  JPY: '¥',
  KRW: '₩',
  TWD: '$',
  USD: '$',
};

export const PERMUTATION_TYPES = {
  ACCUMULATOR: 'ACCUMULATOR',
  PATENT: 'PATENT',
  DOUBLES: 'DOUBLES',
  TRIXIE: 'TRIXIE'
};

export const PRODUCTS = {
  exchange: 'EXCHANGE',
  predictions: 'PREDICTIONS',
  mbzero: 'ZERO',
  casino: 'CASINO',
  liveCasino: 'LIVE-CASINO',
  virtuals: 'VIRTUALS',
};

export const PRODUCT_ROUTES = {
  EXCHANGE: '',
  ZERO: '/zero',
  VIRTUALS: '/virtuals',
  CASINO: '/casino',
  'LIVE-CASINO': '/live-casino',
};

export const PRODUCT_LINKS = [
  { id: PRODUCTS.exchange, name: 'Exchange', longName: 'Exchange', urlName: 'exchange', url: '/' },
  { id: PRODUCTS.predictions, name: 'Predictions', longName: 'Predictions', urlName: 'predictions', url: 'https://predictstreet.matchbook.com' },
  { id: PRODUCTS.mbzero, name: 'MB Zero', longName: 'Matchbook Zero', urlName: 'zero', url: '/zero' },
  { id: PRODUCTS.casino, name: 'Casino', longName: 'Casino', urlName: 'casino', url: '/casino' },
  { id: PRODUCTS.liveCasino, name: 'Live Casino', longName: 'Live Casino', urlName: 'live-casino', url: '/live-casino' },
  { id: PRODUCTS.virtuals, name: 'Virtuals', longName: 'Virtual Sports', urlName: 'virtuals', url: '/virtuals' },
];

export const COMMON_ROUTES = [
  'account',
  'promo',
  'promotions',
  'page',
  'reports',
  'partners',
];

export const SPORT_URL_NAMES = {
  soccer: 'soccer',
  horseRacing: 'horse-racing',
  // To add more when used
};

export const REGIONAL_TAG_URL_NAME = 'regional';

/** URLS */
export const UKGC_LINK = 'https://www.gamblingcommission.gov.uk';

export const TERMS_AND_CONS_LINK = '/page/rules_and_regulations/terms-and-conditions';

export const PRIVACY_POLICY_LINK = '/page/rules_and_regulations/privacy-policy';

export const RED_TIGER_POLICY_LINK = '/page/rules_and_regulations/redtiger-policy';

export const COLOSSUS_POLICY_LINK = '/page/rules_and_regulations/mbcolossus-policy';

export const TRUST_DEED_LINK = 'https://www.matchbook.com/page/none/trust-deed';

export const SAFECHARGE_ORIGIN_PROD = 'https://secure.safecharge.com';

export const APP_STORE_URLS = {
  Android: 'https://play.google.com/store/apps/details?id=com.matchbook.client&hl=en',
  iOS: 'https://apps.apple.com/gb/app/matchbook-betting-exchange/id503101282'
};

export const TRUST_PILOT_LINK = 'https://uk.trustpilot.com/review/matchbook.com?utm_medium=trustbox';

/** IDs */
export const ENTER_KEY_CODE = 13;
export const DOWN_ARROW_KEY_CODE = 40;
export const UP_ARROW_KEY_CODE = 38;
export const ESCAPE_KEY_CODE = 27;

export const UK_COUNTRY_CODE = 204;
export const CANADA_COUNTRY_CODE = 11;
export const IRELAND_COUNTRY_CODE = 35;
export const IRELAND_SHORT_CODE = 'IE';

/** Settings */
export const MARKETING_CONSENT_REMINDER_FREQUENCY = 90; // in days

export const MOBILE_BREAKPOINT = 787;

export const EMPTY_LIST = new List();

export const DEFAULT_NAVIGATION_TAG = new NavigationTag();

export const RACING_SPORTS = ['horse-racing', 'greyhound-racing'];

export const SPORTS_WITH_ADVANCED_MARKETS_VIEW = ['golf', 'horse-racing', 'greyhound-racing', 'formula-1'];

export const FORECAST_MARKET_TYPES = ['forecast', 'reverse_forecast'];

export const OUTRIGHT_MARKET_TYPES = ['outright', 'outright_ded_fact', 'place', 'place_ded_fact', ...FORECAST_MARKET_TYPES];

export const OUTRIGHT_EVENT_TYPES = ['outright-winner', 'outrights'];

export const NUMBER_OUTRIGHT_RUNNERS = 6;

export const MINIMUM_DEPOSIT_AMOUNT = 10;

export const IS_MOBILE = window.innerWidth <= MOBILE_BREAKPOINT;

export const SHOW_UK_OCCUPATION_SALARY_POPUP_DATE = '2022-10-12';

export const ZERO_MAX_STAKE = 20; // 20[$,£,€]

export const ZERO_MAX_PROFIT = 200; // 200[$,£,€]

export const ZERO_NUMBER_REGEX = /(^\d*$)|(^\d{0,}\.\d{0,2}$)/;

/** SEO */
export const PAGE_META_DESCRIPTION = {
  'in-play': 'Enjoy Live Betting on Matchbook Betting Exchange. A better way to bet. ',
  'ante-post': 'Get your bets in early on Matchbook Betting Exchange. Back and Lay, Trade + more. ',
  'ante-post-event': 'Place your bets early on [event-name]. Choose Matchbook Today For A Better Way To Bet.',
  'american-football': 'Get the best odds on American Football on Matchbook Betting Exchange. ',
  'american-football-event': 'Place your bets on [event-name]. Discover why Matchbook is the best betting exchange for American Football. ',
  'australian-rules': 'Get the best odds on Aussie Rules with Matchbook Betting Exchange. ',
  'australian-rules-event': 'Place your bets on [event-name]. Discover why Matchbook is the best betting exchange for Aussie Rules. ',
  baseball: 'Choose Matchbook for a better way to bet on Baseball. ',
  'baseball-event': 'Place your bets on [event-name]. Discover why Matchbook is the best betting exchange for Baseball. ',
  cricket: 'Matchbook is the best betting exchange for Cricket. Back and Lay for a better way to bet. ',
  'cricket-event': 'Place your bets on [event-name]. Discover why Matchbook is the best betting exchange for Cricket.',
  golf: 'Matchbook has the best odds and highest liquidity for betting on Golf.  ',
  'golf-event': 'Place your bets on [event-name]. Discover why Matchbook is the best betting exchange for Golf. ',
  'greyhound-racing': 'Get the best odds and highest liquidity for Greyhound Betting on Matchbook. A better way to bet. ',
  'greyhound-racing-event': 'Pick a winner on the [event-name] greyhounds - get the best odds and liquidity on Matchbook Betting exchange.',
  'enhanced-specials': 'Boost your winnings with an exclusive Enhanced Odds special bet from Matchbook',
  'enhanced-specials-event': 'Boost your winnings with an exclusive Enhanced Odds special bet from Matchbook',
  'horse-racing': 'Get great odds and high liquidity on the Horse Racing on Matchbook.com. The best betting exchange for Horse Racing.',
  'horse-racing-event': "Pick a winner on the [event-name] Horse Racing on Matchbook. The UK's Best Betting Exchange.",
  'ice-hockey': 'Get the best odds and highest liquidity for Ice Hockey on Matchbook. A better way to bet. ',
  'ice-hockey-event': 'Place your bets on [event-name]. Discover why Matchbook is the best betting exchange for Ice Hockey.',
  politics: 'The Best Site for the Informed Bettor. Back & Lay Bets, Trade, Plus More on Matchbook.com',
  'politics-event': 'Back the outcome of [event-name] on Matchbook.com. The best betting exchange for politics. ',
  'rugby-league': 'Get the best odds and highest liquidity for Rugby-league on Matchbook. A better way to bet. ',
  'rugby-league-event': 'Get the best odds on [event-name] in the [event-competition] on [start-time]. Matchbook Betting Exchange, the best odds on Rugby. ',
  'rugby-union': 'Get the best odds and highest liquidity for Rugby on Matchbook. A better way to bet. ',
  'rugby-union-event': 'Get the best odds on [event-name] in the [event-competition] on [start-time]. Matchbook Betting Exchange, the best odds on Rugby.',
  soccer: 'Get the best odds and highest liquidity for Football on Matchbook. A better way to bet. ',
  'soccer-event': 'Get the best odds on [event-name] in the [event-competition] on [start-time]. Matchbook Betting Exchange, the best odds on Football',
  tennis: 'Get the best odds and highest liquidity for Tennis on Matchbook. A better way to bet. ',
  'tennis-event': 'Who will win in [event-name]? get the best odds and live betting on Matchbook.com. The best betting exchange for tennis',
};

/** KYC */
export const EMPLOYMENT_STATUS_OPTIONS = [
  { id: 'FULL_TIME_EMPLOYED', value: 'FULL_TIME_EMPLOYED', name: 'Full Time Employed', },
  { id: 'SELF_EMPLOYED', value: 'SELF_EMPLOYED', name: 'Self Employed', },
  { id: 'UNEMPLOYED', value: 'UNEMPLOYED', name: 'Unemployed', },
  { id: 'MATCHED_BETTOR', value: 'MATCHED_BETTOR', name: 'Matched Bettor', },
  { id: 'PROFESSIONAL_GAMBLER', value: 'PROFESSIONAL_GAMBLER', name: 'Professional Gambler', },
  { id: 'RETIRED', value: 'RETIRED', name: 'Retired', },
  { id: 'STUDENT', value: 'STUDENT', name: 'Student', },
  { id: 'PART_TIME_EMPLOYED', value: 'PART_TIME_EMPLOYED', name: 'Part Time Employed', },
];

/** DEV */
export const BETA_HOSTS = [
  'local.matchbook.com:3000',
  'beta.matchbook.com',
  'hooyu.aws.xcl.ie',
  'integrations-hooyu.xcl.ie',
];

export const PROD_ORIGINS = [
  'www.matchbook.com',
  'beta.matchbook.com',
];

/** PARTNER LOGOS FOR RESPONSIBLE GAMBLING PAGE */
export const ALDERNEY_URL = 'https://www.gamblingcontrol.org';
export const GAMBLING_CONTROL = 'https://www.gamblingcommission.gov.uk/public-register/business/detail/39504';
export const GAMBLING_CONTROL_HOME = 'https://www.gamblingcontrol.org/';
export const GAME_CARE_URL = 'http://www.gamcare.org.uk';
export const GAMSTOP_URL = 'https://www.gamstop.co.uk';
export const TTTT_URL = 'https://www.taketimetothink.co.uk/';
export const PLUS18_URL = 'https://www.matchbook.com/page/rules_and_regulations/underagegambling';
export const FB_MATCHBOOK = 'https://www.facebook.com/MatchbookBettingExchange';
export const X_MATCHBOOK = 'https://twitter.com/TeamMatchBook';
export const UKGC_ACCOUNT_NUMBER = 'https://registers.gamblingcommission.gov.uk/39504';
export const TIME_TO_THINK = 'https://www.taketimetothink.co.uk/';
export const BET_BLOCKER = 'https://betblocker.org/';
export const GRAI_URL = 'https://www.grai.ie/';
export const GRAI_ACCOUNT_NUMBER = 'https://www.matchbook.com/page/about/grai-irish-licence';

/** Responsible gambling modal */
export const PERIOD_OPTIONS = [
  {
    id: 'daily',
    name: 'Daily',
    text: 'day'
  },
  {
    id: 'weekly',
    name: 'Weekly',
    text: 'week'
  },
  {
    id: 'monthly',
    name: 'Monthly',
    text: 'month'
  },
];

export const TIMEOUT_TIMES = [
  { id: '1', name: '1' },
  { id: '2', name: '2' },
  { id: '3', name: '3' },
  { id: '4', name: '4' },
  { id: '5', name: '5' },
  { id: '6', name: '6' },
];

export const TIMEOUT_PRODUCT = [
  {
    name: 'Casino Only',
    id: 'casino'
  },
  {
    name: 'All Products',
    id: 'all'
  },
];

export const TIMEOUT_PERIODS = [
  {
    name: 'Days',
    id: 'days'
  },
  {
    name: 'Weeks',
    id: 'weeks'
  },
];

export const SELF_EXCLUDE_PERIODS = [
  {
    name: '6 Months',
    id: '6-months'
  },
  {
    name: '1 Year',
    id: '1-years'
  },
  {
    name: '1.5 Years',
    id: '1.5-years'
  },
  {
    name: '2 Years',
    id: '2-years'
  },
  {
    name: '2.5 Years',
    id: '2.5-years'
  },
  {
    name: '3 Years',
    id: '3-years'
  },
  {
    name: '3.5 Years',
    id: '3.5-years'
  },
  {
    name: '4 Years',
    id: '4-years'
  },
  {
    name: '4.5 Years',
    id: '4.5-years'
  },
  {
    name: '5 Years',
    id: '5-years'
  },
];

export const MONTHLY_INCOME_RANGE = [
  { start: '0', end: '750' },
  { start: '751', end: '1500' },
  { start: '1501', end: '2250' },
  { start: '2251', end: '3000' },
  { start: '3001', end: '3750' },
  { start: '3751', end: '4500' },
  { start: '4501', end: '5250' },
  { start: '5251', end: '6000' },
  { start: '6000' },
];

export const OCCUPATION_LIST = [
  { id: 1, value: 'Gambling', name: 'Gambling' },
  { id: 2, value: 'Matched Bettor', name: 'Matched Bettor' },
  { id: 3, value: 'Accountant', name: 'Accountant' },
  { id: 4, value: 'Administrative Work', name: 'Administrative Work' },
  { id: 5, value: 'Advertising / Marketing', name: 'Advertising / Marketing' },
  { id: 6, value: 'Architect', name: 'Architect' },
  { id: 7, value: 'Auditor', name: 'Auditor' },
  { id: 8, value: 'Automotive / Mechanic', name: 'Automotive / Mechanic' },
  { id: 9, value: 'Banking', name: 'Banking' },
  { id: 10, value: 'Business Owner', name: 'Business Owner' },
  { id: 11, value: 'Catering', name: 'Catering' },
  { id: 12, value: 'Civil Service', name: 'Civil Service' },
  { id: 13, value: 'Cleaning', name: 'Cleaning' },
  { id: 14, value: 'Construction / Tradesperson', name: 'Construction / Tradesperson' },
  { id: 15, value: 'Courier', name: 'Courier' },
  { id: 16, value: 'Dentist', name: 'Dentist' },
  { id: 17, value: 'Director / C-Level', name: 'Director / C-Level' },
  { id: 18, value: 'Doctor', name: 'Doctor' },
  { id: 19, value: 'Driving instructor', name: 'Driving instructor' },
  { id: 20, value: 'Education', name: 'Education' },
  { id: 21, value: 'Engineer', name: 'Engineer' },
  { id: 22, value: 'Entertainment / Actor / Musician', name: 'Entertainment / Actor / Musician' },
  { id: 23, value: 'Farming', name: 'Farming' },
  { id: 24, value: 'Finance', name: 'Finance' },
  { id: 25, value: 'Firefighter', name: 'Firefighter' },
  { id: 26, value: 'Flight Steward', name: 'Flight Steward' },
  { id: 27, value: 'Hairdresser / Barber', name: 'Hairdresser / Barber' },
  { id: 28, value: 'Hospitality / Restaurant / Bar staff', name: 'Hospitality / Restaurant / Bar staff' },
  { id: 29, value: 'Human Resources', name: 'Human Resources' },
  { id: 30, value: 'Insurance', name: 'Insurance' },
  { id: 31, value: 'Investments', name: 'Investments' },
  { id: 32, value: 'Information Technology', name: 'Information Technology' },
  { id: 33, value: 'Legal', name: 'Legal' },
  { id: 34, value: 'Military', name: 'Military' },
  { id: 35, value: 'Nurse', name: 'Nurse' },
  { id: 36, value: 'Other Healthcare Support Occupation', name: 'Other Healthcare Support Occupation' },
  { id: 37, value: 'Other Occupation', name: 'Other Occupation' },
  { id: 38, value: 'Pharmacist', name: 'Pharmacist' },
  { id: 39, value: 'Pilot', name: 'Pilot' },
  { id: 40, value: 'Police Officer', name: 'Police Officer' },
  { id: 41, value: 'Real Estate', name: 'Real Estate' },
  { id: 42, value: 'Retail', name: 'Retail' },
  { id: 43, value: 'Retired', name: 'Retired' },
  { id: 44, value: 'Sales Manager', name: 'Sales Manager' },
  { id: 45, value: 'Sales Representative', name: 'Sales Representative' },
  { id: 46, value: 'Social Worker', name: 'Social Worker' },
  { id: 47, value: 'Student', name: 'Student' },
  { id: 48, value: 'Technician', name: 'Technician' },
  { id: 49, value: 'Therapist', name: 'Therapist' },
  { id: 50, value: 'Tourism', name: 'Tourism' },
  { id: 51, value: 'Transportation', name: 'Transportation' },
  { id: 52, value: 'Unemployed', name: 'Unemployed' },
  { id: 53, value: 'Veterinarian', name: 'Veterinarian' },
];

export const ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'];

export const CASINO_LAYOUTS = {
  DEFAULT: 'LAYOUT_FEATURED',
  AZ: 'LAYOUT_AZ',
};

export const CANADA_PROVINCES = [
  {
    'region-id': 355,
    name: 'British Columbia',
    'region-code': 'BC',
    id: 'British Columbia',
  },
  {
    'region-id': 356,
    name: 'Manitoba',
    'region-code': 'MB',
    id: 'Manitoba',
  },
  {
    'region-id': 357,
    name: 'New Brunswick',
    'region-code': 'NB',
    id: 'New Brunswick',
  },
  {
    'region-id': 358,
    name: 'Newfoundland and Labrador',
    'region-code': 'NF',
    id: 'Newfoundland and Labrador',
  },
  {
    'region-id': 359,
    name: 'Northwest Territories',
    'region-code': 'NT',
    id: 'Northwest Territories',
  },
  {
    'region-id': 360,
    name: 'Nova Scotia',
    'region-code': 'NS',
    id: 'Nova Scotia',
  },
  {
    'region-id': 361,
    name: 'Nunavut',
    'region-code': 'NU',
    id: 'Nunavut',
  },
  {
    'region-id': 363,
    name: 'Prince Edward Island',
    'region-code': 'PE',
    id: 'Prince Edward Island',
  },
  {
    'region-id': 364,
    name: 'Quebec',
    'region-code': 'QC',
    id: 'Quebec',
  },
  {
    'region-id': 365,
    name: 'Saskatchewan',
    'region-code': 'SK',
    id: 'Saskatchewan',
  },
  {
    'region-id': 366,
    name: 'Yukon',
    'region-code': 'YT',
    id: 'Yukon',
  }
];


export const PODCAST_USER_RETURN_THRESHOLD = 30000;

export const PINNED_BETSLIP_CONFIGURATION = {
  [PRODUCTS.exchange]: false,
  [PRODUCTS.mbzero]: false,
  [PRODUCTS.casino]: true,
  [PRODUCTS.liveCasino]: true,
  [PRODUCTS.virtuals]: true,
};

export const ERROR_MESSAGES = {
  INSUFFICIENT_FUNDS: ['Insufficient funds'],
  UNAUTHORIZED_ACCESS: ['not authorised to access'],
  ODDS_NOT_AVAILABLE: ['Odds not available'],
  INVALID_LEGS: ['Invalid Legs'],
  NOT_AVAILABLE_IN_PLAY: ['Not available In-Play'],
  EVENT_MUST_BE_OPEN: ['Event must be open'],
  ODDS_TYPE_MISMATCH: ['Odds Type Mismatch'],
  BET_BUILDER_RESTRICTED_IE: ['Unavailable for IE'],
};

// Release Notes launch date
export const RELEASE_DATE = '08-03-2024';
